module.exports = __webpack_public_path__ + "static/media/15.13ef9177.jpg";